import { NotificationID } from '../../../shared/models/id/notification_id'
import { Button, Modal } from 'react-bootstrap'
import React from 'react'
import {
  useLazyGetNotificationQuery,
  useMarkAsReadMutation,
} from '../../../store/kopiliot-api/notification'
import { formatDate } from '../../../helpers/utls'

interface Props {
  id?: NotificationID
  show?: boolean
  onHide: () => void
}

const ViewNotification = ({ id, show, onHide }: Props) => {
  const [get, result] = useLazyGetNotificationQuery()
  const [read, resultRead] = useMarkAsReadMutation()
  React.useEffect(() => {
    if (id) {
      get(id)
    }
  }, [id?.id])
  return (
    <Modal show={show} onHide={onHide} size={'xl'} centered>
      <Modal.Header>
        <Modal.Title>
          {result.isLoading || !result.data ? 'Loading' : result.data.subject}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className={'d-flex justify-content-end'}>
          {result.data?.createdAt &&
            formatDate(result.data.createdAt, false, 'DD/MM/YYYY HH:mm:ss')}
        </div>
        <p className={'fs-7'}>
          {result.isLoading ? 'Loading...' : result.data && result.data.body}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <div className={'d-flex justify-content-end'}>
          <Button
            variant={'outline-primary'}
            onClick={() => {
              if (result.data?.id && result.data.status == 'SENT') {
                read(result.data.id)
              }
              onHide()
            }}
          >
            Fermer {result.data?.status == 'SENT' && ' et marquer comme lu'}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  )
}

export default ViewNotification
